// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__eAE1Z","productName":"Table_productName__1-hj2"};